module.exports = __webpack_public_path__ + "img/button_X2.ec4f0633.svg";